import * as Yup from "yup";
import NepaliDate from "nepali-date-converter";

// const NepaliDate = new NepaliDate(Date.now());
// console.log("nep date:", NepaliDate);
const CreateReportValidation = Yup.object({
  name: Yup.string().required("Name is required"),
  reportTypeId: Yup.object()
    .shape({
      label: Yup.string().required("Report Type Label is required"),
      value: Yup.string().required("Report Type is required"),
    })
    .required("Report Type is required"),
  year: Yup.object()
    .shape({
      value: Yup.number()
        .integer("Year must be an integer")
        .min(
          new NepaliDate().getYear() - 10,
          "Year must be greater than or equal to the current year minus 10 ${}"
        )
        .max(
          new NepaliDate().getYear() + 10,
          "Year must be less than or equal to the current year plus 10"
        )
        .required("Year is required"),
    })
    .required("Year is required"),
  month: Yup.object()
    .shape({
      value: Yup.number()
        .min(1, "Invalid Month")
        .max(12, "Invalid Month")
        .required("Month is required"),
    })
    .required("Month is required"),
  reportTxnsDummy: Yup.array(),
  reportTxns: Yup.array().of(
    Yup.object().shape({
      reportSubTxnDtos: Yup.array().of(
        Yup.object().shape({
          subTxnDtos: Yup.array().of(
            Yup.object().shape({
              // Define validation for subTxnDtos if needed
            })
          ),
        })
      ),
    })
  ),
});

export default CreateReportValidation;
